import { Injectable } from '@angular/core';
import {ErrorService} from './../shared/services/error.service'
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, Subject } from 'rxjs';
import { map, catchError, timeout, retryWhen, delay, take, takeUntil, finalize, throwIfEmpty } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Configuration } from '../../app.constants';


@Injectable()
export class HTTPStatus {
    private requestInFlight$: BehaviorSubject<boolean>;

    constructor() {
        this.requestInFlight$ = new BehaviorSubject(false);
    }

    setHttpStatus(inFlight: boolean) {
        this.requestInFlight$.next(inFlight);
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
}

@Injectable()
export class HTTPListener implements HttpInterceptor {

    private numRequests = 0;
    private cancelRetry$ = new Subject<void>(); // Subject to signal retry cancellation

    constructor(private status: HTTPStatus, public errorService: ErrorService, private router: Router) { 
         // Listen for navigation events to cancel retries on route changes
         this.router.events.subscribe(() => {
            this.cancelRetry$.next(); // Emit a signal when navigation occurs
        });
    }

    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.status.setHttpStatus(true);
        this.numRequests++;

        if (req.method === 'POST') {
            return next
                .handle(req)
                .pipe(
                    map(event => {
                        if (event instanceof HttpResponse) {
                            this.decrementRequestCounter();
                        }
                        return event;
                    }),
                    catchError((error: HttpErrorResponse) => {
                        this.handleError(error);
                        return throwError(() => error); // Rethrow the error after handling
                    })
                    , timeout({first: 45000}) // add 45 second timeout for POST
            ); 
        } else {
            return next
                .handle(req)
                .pipe(
                    map(event => {
                        if (event instanceof HttpResponse) {
                            this.decrementRequestCounter();
                        }
                        return event;
                    }),
                    catchError((error: HttpErrorResponse) => {
                        this.handleError(error);
                        return throwError(() => error); // Rethrow the error after handling
                    }),
                    retryWhen(errors =>
                        errors.pipe(
                            delay(3000), // Retry after 3 seconds
                            take(2), // Retry up to 10 times
                            takeUntil(this.cancelRetry$) // Cancel retries if navigation occurs
                           
                        )
                    )
                    , timeout({first: 30000}) // add 30 second timeout
            )
        }
        
    }

       // Decrements the active request counter and updates the HTTP status.
    private decrementRequestCounter(): void {
        this.numRequests--;
        if (this.numRequests <= 0) {
            this.status.setHttpStatus(false);
        }
    }

    // Handles errors, sets HTTP status, and logs the error to the ErrorService.
    private handleError(error: HttpErrorResponse): void {
        this.status.setHttpStatus(false);
        this.numRequests = 0;
        this.errorService.error = error.status;
        console.error('HTTP Error:', error);
    }
}
